import { render } from "./UploadMultiImageNew.vue?vue&type=template&id=492a48d4&scoped=true"
import script from "./UploadMultiImageNew.vue?vue&type=script&lang=js"
export * from "./UploadMultiImageNew.vue?vue&type=script&lang=js"

import "./UploadMultiImageNew.vue?vue&type=style&index=0&id=492a48d4&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-492a48d4"]])

export default __exports__